import { useQuery } from "@tanstack/react-query";
import { Wifi, WifiOff, Radio } from "lucide-react";

import { api } from "@/lib/api";
import { cn } from "@/lib/utils";

export function EnvBanner() {
  const { data, isError } = useQuery({
    queryKey: ["health"],
    queryFn: api.health,
    refetchInterval: 15_000,
  });

  if (isError) {
    const isProdEnv = !!import.meta.env.VITE_API_URL;
    return (
      <div className="flex items-center gap-2 px-6 py-1.5 text-xs bg-rose-950/60 text-rose-300 border-b border-rose-900/60">
        <WifiOff className="h-3.5 w-3.5" />
        {isProdEnv
          ? <span>API unreachable — check Worker deployment</span>
          : <span>sync-go unreachable — run <code className="font-mono bg-rose-900/40 px-1 rounded">mise run up</code> to start the stack</span>
        }
      </div>
    );
  }

  if (!data) return <div className="h-8 border-b border-border/40" />;

  const isProd = data.shopify_env === "production";

  return (
    <div className={cn(
      "flex items-center gap-3 px-6 py-1.5 text-xs border-b",
      isProd
        ? "bg-rose-950/40 border-rose-900/50 text-rose-300/90"
        : "bg-muted/30 border-border/40 text-muted-foreground",
    )}>
      <div className="flex items-center gap-1.5">
        {isProd
          ? <Radio className="h-3 w-3 text-rose-400" />
          : <Wifi className="h-3 w-3 text-emerald-400" />}
        <span className={cn("font-semibold tracking-wide", isProd ? "text-rose-300" : "text-emerald-400")}>
          {isProd ? "LIVE" : "MOCK"}
        </span>
        <span className="opacity-50">·</span>
        <span>asd4h8-ux.myshopify.com</span>
      </div>

      <span className="opacity-40">|</span>

      <div className="flex items-center gap-2 opacity-60">
        <span className={cn("h-1.5 w-1.5 rounded-full inline-block", data.db === "ok" ? "bg-emerald-400" : "bg-rose-400")} />
        <span>DB {data.db === "ok" ? "ok" : "down"}</span>
      </div>

      {isProd && (
        <span className="ml-auto opacity-50 font-mono">
          writes confirmed per action
        </span>
      )}
    </div>
  );
}
